import type { RouteObject } from "react-router-dom";
import { StoreInviteAcceptPage } from "./pages/StoreInviteAcceptPage";

export const teamRoutes: RouteObject[] = [
  {
    path: "store-invite/:token",
    element: <StoreInviteAcceptPage />,
  },
];
